

<div class="matero-topmenu " [ngClass]="{'menu-semitransparent': menuTransparent === true}">
  <div class="top-sidebar">
    <div class="top-sidebar-content">
       <span class="pointer" style="    vertical-align: top;" fxHide.lt-md *ngIf="socials && socials.length > 0">
        <a *ngFor="let social of socials" style="color: #fff" class="mat-social pointer" fxHide.lt-sm target="new" href="{{ social.value }}">
              <mat-icon class="pointer" *ngIf="social.icon.includes('svg_')" svgIcon="{{ social.icon }}"> </mat-icon>
              <mat-icon class="pointer" *ngIf="!social.icon.includes('svg_')"> {{ social.icon }}</mat-icon>
        </a>
        <a *ngIf="entity?.shopUrl != null" style="color: #fff" class=" mat-social pointer" fxHide.lt-sm target="new" href="{{ entity?.shopUrl }}">
          <mat-icon class="pointer" style="padding-top:1px;">shopping_cart</mat-icon>
          
    </a>

      <a href="https://www.yulava.com/" target="new">
          <img src="{{environment.assetsUrl}}assets/images/icon_yulava.svg" style="height: 16px;margin-bottom:2px;margin-right: 6px;">
      </a>
      </span>
      <a href="https://connect.yulava.com/" target="new">
        <button mat-flat-button 
        class="yulava_button">{{ 'general.access' | translate }}</button></a>
      <a href="https://play.google.com/store/apps/details?id=com.yulava.connect" target="new" class="app-store-logo">
        <img src="{{environment.assetsUrl}}assets/icons/android.svg" title="Google Play" alt="Google Play" style="height: 24px;border-radius: var(--client-radius);">
    </a>
    <a href="https://apps.apple.com/es/app/yulava-connect/id1533240784" target="new" class="app-store-logo">
        <img src="{{environment.assetsUrl}}assets/icons/ios.svg" title="App Store" alt="App Store" style="height: 24px;border-radius: var(--client-radius);">
    </a>
     
    </div>
   
  </div>
  <div class="matero-topmenu-content" style="max-width: 1100px;margin: 0 auto;min-height: 100px;">
  <div style="flex:1;"> 
    <a *ngIf="entity$ | async; let entity" class="matero-branding" style="height:100%;align-items: center;" href="#" [routerLink]="'/'">
      <img appImgFallback   src="{{(entity.image) ? sharedService.getImage(entity.image) : sharedService.getImage(defaultImageEntity)}}" style="max-height:70px;position:relative;float: left;" alt="logo" />
      <div class="matero-branding-name" style="align-self: center;"><span style="color:var(--text-color)">{{entity.name}}</span></div>
    </a>
  </div>
  <div class="matero-topmenu-content-nav" style="flex:4;align-self: center;text-align: right;">
    <nav style="padding-left: 24px;">
      <ng-container *ngFor="let menuItem of menus | async">
  
      <button *ngIf="menuItem.type === 'link' && (menuItem.visible == undefined || menuItem.visible)" mat-button [routerLink]="buildRoute([menuItem.route])"
        routerLinkActive="active">
        <!-- <mat-icon class="menu-icon"><i class="{{menuItem.icon}}"></i></mat-icon> -->
  
        <span class="menu-name">{{menuItem.name | translate}}</span>
        <span *ngIf="menuItem.label" class="badge menu-label bg-{{menuItem.label.color}}">
          {{menuItem.label.value}}
        </span>
        <span *ngIf="menuItem.badge" class="badge menu-badge bg-{{menuItem.badge.color}}">
          {{menuItem.badge.value}}
        </span>
      </button>
      <a *ngIf="menuItem.type === 'extLink'" mat-button [href]="menuItem.route">
        <!-- <mat-icon class="menu-icon"><i class="{{menuItem.icon}}"></i></mat-icon> -->
        <span class="menu-name">{{menuItem.name | translate}}</span>
        <span *ngIf="menuItem.label" class="badge menu-label bg-{{menuItem.label.color}}">
          {{menuItem.label.value}}
        </span>
        <span *ngIf="menuItem.badge" class="badge menu-badge bg-{{menuItem.badge.color}}">
          {{menuItem.badge.value}}
        </span>
        <mat-icon>launch</mat-icon>
      </a>
      <a *ngIf="menuItem.type === 'extTabLink'" mat-button [href]="menuItem.route" target="_blank">
        <!-- <mat-icon class="menu-icon"><i class="{{menuItem.icon}}"></i></mat-icon> -->
        <span class="menu-name">{{menuItem.name | translate}}</span>
        <span *ngIf="menuItem.label" class="badge menu-label bg-{{menuItem.label.color}}">
          {{menuItem.label.value}}
        </span>
        <span *ngIf="menuItem.badge" class="badge menu-badge bg-{{menuItem.badge.color}}">
          {{menuItem.badge.value}}
        </span>
        <mat-icon>launch</mat-icon>
      </a>
  
      <button mat-button *ngIf="menuItem.type === 'sub'" [matMenuTriggerFor]="menulevel1"
              routerLinkActive="active">
        <!-- <mat-icon class="menu-icon"><i class="{{menuItem.icon}}"></i></mat-icon> -->
        <span class="menu-name">{{menuItem.name | translate}}<mat-icon class="menu-caret">keyboard_arrow_down</mat-icon></span>
        <span *ngIf="menuItem.label" class="badge menu-label bg-{{menuItem.label.color}}">
          {{menuItem.label.value}}
        </span>
        <span *ngIf="menuItem.badge" class="badge menu-badge bg-{{menuItem.badge.color}}">
          {{menuItem.badge.value}}
        </span>
        
  
  
        <mat-menu #menulevel1="matMenu">
          <ng-container *ngFor="let childLvl1 of menuItem.children">
  
            <button *ngIf="childLvl1.type === 'link'" mat-menu-item
              [routerLink]="buildRoute([menuItem.route, childLvl1.route])"
              routerLinkActive="active">
              {{childLvl1.name | translate}}
            </button>
            <a *ngIf="childLvl1.type === 'extLink'" mat-menu-item [href]="childLvl1.route">
              <span class="menu-name">{{childLvl1.name | translate}}</span>
              <mat-icon>launch</mat-icon>
            </a>
            <a *ngIf="childLvl1.type === 'extTabLink'" mat-menu-item [href]="childLvl1.route"
              target="_blank">
              <span class="menu-name">{{childLvl1.name | translate}}</span>
              <mat-icon>launch</mat-icon>
            </a>
  
            <button *ngIf="childLvl1.type === 'sub'" mat-menu-item [matMenuTriggerFor]="menulevel2"
                    routerLinkActive="active">
              {{childLvl1.name | translate}}
  
  
              <mat-menu #menulevel2="matMenu">
                <ng-container *ngFor="let childLvl2 of childLvl1.children">
                  <button *ngIf="childLvl2.type === 'link'" mat-menu-item
                    [routerLink]="buildRoute([menuItem.route, childLvl1.route, childLvl2.route])"
                    routerLinkActive="active">
                    {{childLvl2.name | translate}}
                  </button>
                  <a *ngIf="childLvl2.type === 'extLink'" mat-menu-item [href]="childLvl2.route">
                    <span class="menu-name">{{childLvl2.name | translate}}</span>
                    <mat-icon>launch</mat-icon>
                  </a>
                  <a *ngIf="childLvl2.type === 'extTabLink'" mat-menu-item [href]="childLvl2.route"
                    target="_blank">
                    <span class="menu-name">{{childLvl2.name | translate}}</span>
                    <mat-icon>launch</mat-icon>
                  </a>
                </ng-container>
              </mat-menu>
            </button>
  
          </ng-container>
        </mat-menu>
      </button>
    </ng-container>
    
    </nav>
  </div>
  
</div>

</div>





